import { Link, useLocation } from 'react-router-dom';

const ITEMS = [
  { label: '首页', icon: 'ri-home-4-line', activeIcon: 'ri-home-4-fill', to: '/', match: (p: string) => p === '/' },
  { label: '电影', icon: 'ri-movie-line', activeIcon: 'ri-movie-fill', to: '/category/movie', match: (p: string) => p.startsWith('/category/movie') },
  { label: '剧集', icon: 'ri-tv-2-line', activeIcon: 'ri-tv-2-fill', to: '/category/tv', match: (p: string) => p.startsWith('/category/tv') },
  { label: '收藏', icon: 'ri-heart-line', activeIcon: 'ri-heart-fill', to: '/favorites', match: (p: string) => p.startsWith('/favorites') },
  { label: '搜索', icon: 'ri-search-line', activeIcon: 'ri-search-eye-line', to: '/search', match: (p: string) => p.startsWith('/search') },
];

export default function MobileBottomNav() {
  const location = useLocation();
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur border-t border-background-200">
      <div className="flex items-center justify-around h-14">
        {ITEMS.map((item) => {
          const active = item.match(location.pathname);
          return (
            <Link
              key={item.label}
              to={item.to}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full cursor-pointer transition-colors ${
                active ? 'text-primary-500' : 'text-foreground-500'
              }`}
            >
              <i className={`${active ? item.activeIcon : item.icon} text-lg`}></i>
              <span className="text-[10px]">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}